module.exports = __webpack_public_path__ + "img/icon-timer.8980dddd.svg";